import { Component, OnInit } from '@angular/core';
import { BreadCrumbsService } from './breadcrumbs.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Logger } from '../../../../common';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  template: `
    <nav>
      <h5>{{ breadcrumbs[0]?.label | translate }}</h5>
      <ul class="breadcrumb">
        <li *ngFor="let breadcrumb of breadcrumbs; let i = index">
          <a (click)="onRouteLink(breadcrumb)">
            {{ breadcrumb.label | translate }}
            <span *ngIf="i < breadcrumbs.length - 1"> > </span>
          </a>
        </li>
      </ul>
    </nav>
  `,
  styleUrls: ['./bread-crumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: any[] = [];
  routeData: any;
  constructor(
    private breadcrumbService: BreadCrumbsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$.subscribe((breadcrumbs) => {
      this.breadcrumbs = breadcrumbs;
      Logger.debug(breadcrumbs);
    });
  }
  onRouteLink(breadcrumb: any) {
    this.router.navigate([breadcrumb.url], { state: { data: breadcrumb?.data } });
  }
}
